import PropTypes from 'prop-types';
import React from 'react';
import FilterCheckboxes from '../FilterCheckboxes';

/**
 *  Filter By Style renders a group of checkbox elements with image element and
 *  custom styling
 *
 */
import { jsx as _jsx } from "react/jsx-runtime";
function FilterByStyle(props) {
  const getFilterOptions = formattedOptions => formattedOptions && formattedOptions.map(option => ({
    ...option,
    label: option.label,
    src: option.src || `//www.autotrader.com/content/dam/autotrader/homepage/styles/DefaultDesk_Style_${option.value}.png`
  }));
  return /*#__PURE__*/_jsx(FilterCheckboxes, {
    customFilterOptions: getFilterOptions,
    className: "visual-checkboxes",
    ...props
  });
}
export default FilterByStyle;